// ApiFailure (03-dominio.md): what `Api_Functions` throws, told apart by what matters to the screen. `apiGet` throws
// `{status, name, data, message}` for a non-2xx answer (`message = data.message || data.error`), an `AbortError` when the
// caller aborted, and RESOLVES `undefined` when it already redirected to /connection_error (the caller checks that).
//
//   aborted          the caller aborted its own request: say nothing
//   springForbidden  403 whose `message` is not the one of the contract: Spring's own body ({error: "Forbidden"})
//                    or none. It means "no permission", and it is recognised by the `message`, never by the absence of
//                    a body (enmienda A201-1, GATE2-G1)
//   contract         `{message: DATA_CORRECTION_…, details}`: the contract of stories 189 and 201
//   unexpected       anything else (a 500 without a contract body, …)

const CONTRACT_403 = ['DATA_CORRECTION_ACTOR_NOT_A_USER']
const CONTRACT_PREFIX = 'DATA_CORRECTION_'

export const classifyFailure = (error) => {
  const failure = error || {}
  if (failure.name === 'AbortError') return { kind: 'aborted', status: 0, message: '', details: {} }
  const status = failure.status || 0
  const body = failure.data && typeof failure.data === 'object' && !Array.isArray(failure.data) ? failure.data : {}
  const bodyMessage = typeof body.message === 'string' ? body.message : ''
  const message = bodyMessage || (typeof failure.message === 'string' ? failure.message : '')
  if (status === 403 && !CONTRACT_403.includes(message)) return { kind: 'springForbidden', status, message, details: {} }
  if (bodyMessage.startsWith(CONTRACT_PREFIX)) return { kind: 'contract', status, message: bodyMessage, details: body.details || {} }
  return { kind: 'unexpected', status, message, details: {} }
}
